export default __webpack_public_path__ + "static/news32-75bf230b3a98838bc084fff8d9d734ed.png";